import { ReservationService } from '../Services/Reservation/reservation.service';
import { BaseDataSource } from './base.data-source';

export class ReservationsDataSource extends BaseDataSource {
  constructor(private reservationService: ReservationService) {
    super();
  }

  loadReservations(pageNumber = 0, pageSize = 10) {
    this.reservationService.getMyReservations(pageNumber, pageSize).subscribe((r) => {
      r = r.value;
      this.setDataCount(r.count);
      this.subject.next(r.result);
    });
  }

  loadAllReservations(pageNumber = 0, pageSize = 10, reservationFilter = '') {
    this.reservationService
      .getAllReservations(pageNumber, pageSize, reservationFilter)
      .subscribe((r) => {
        r = r.value;
        this.setDataCount(r.count);
        this.subject.next(r.result);
      });
  }

  removeReservations(reservationIds: ReadonlySet<number>): void {
    if (reservationIds.size === 0) {
      return;
    }

    const currentReservations = this.subject.value;
    const remainingReservations = currentReservations.filter(
      (reservation: any) => !reservationIds.has(Number(reservation?.id))
    );
    const removedCount = currentReservations.length - remainingReservations.length;

    if (removedCount > 0) {
      this.subject.next(remainingReservations);
      this.setDataCount(Math.max(0, this.dataCount - removedCount));
    }
  }
}
